(function () {
  'use strict';

  const { BaseCarousel } = window.Universe;

  class AnnouncementBar {
    constructor() {
      this.init();
    }

    reinit() {
      this.destroy();
      this.init();
    }

    setup() {
      if (this.DOM.carousel) {
        this.carouselInstance = new BaseCarousel({
          wrap: this.DOM.carousel,
          carouselOptions: {
            align: 'center',
            loop: true,
            watchDrag: false,
          },
          withAutoScroll: false,
          withAutoPlay: 'autoplay' in this.DOM.carousel.dataset,
          onReady: () => {
            if (this.carouselInstance.instance && this.DOM.carouselAnnouncement) {
              this.carouselInstance.instance.on('select', () => {
                this.announceCarouselSlide();
              });
            }
          },
        });
      }
    }

    announceCarouselSlide() {
      if (!this.DOM.carouselAnnouncement || !this.carouselInstance || !this.carouselInstance.instance) return;

      const currentSlide = this.carouselInstance.instance.selectedScrollSnap() + 1;
      const totalSlides = this.carouselInstance.instance.scrollSnapList().length;
      const label = this.DOM.carouselAnnouncement.dataset.label || 'Announcement [current] of [total]';
      this.DOM.carouselAnnouncement.textContent = label.replace('[current]', currentSlide).replace('[total]', totalSlides);
    }

    destroy() {
      if (this.DOM) {
        if (this.carouselInstance) {
          this.carouselInstance.destroy();
          this.carouselInstance = undefined;
        }
        this.DOM = undefined;
      }
    }

    init(container = document) {
      const wrap = container.querySelector('.js-announcement-bar');

      if (wrap) {
        this.DOM = {};
        this.DOM.wrap = wrap;
        this.DOM.carousel = this.DOM.wrap.querySelector('.js-announcement-bar-carousel');
        this.DOM.carouselAnnouncement = this.DOM.wrap.querySelector('.js-announcement-carousel-announcement');

        this.carouselInstance = undefined;

        this.setup();
      }
    }
  }

  window.Universe.AnnouncementBar = AnnouncementBar;
})();
